module.exports = __webpack_public_path__ + "img/qualificationImage4.13a52202.jpg";